export const projectTypes = [
	{
		text: "Red Hat Enterprise Linux Application",
		value: "RHEL",
	},
	{
		text: "OpenStack Plugin",
		value: "OpenStack",
	},
	{
		text: "Helm Chart",
		value: "Helm Chart",
	},
	{
		text: "OpenShift CNF",
		value: "OpenShift-cnf",
	},
	{
		text: "Openstack VNF",
		value: "OpenStack-vnf",
	},
	{
		text: "OpenShift Virtualization",
		value: "OpenShift-virtualization",
	},
];

export const openstackProjectTypes = [
	{
		text: "OpenStack Infrastructure Non-Containerized",
		value: "OpenStack-infra-noncontainer",
	},
	{
		text: "OpenStack Infrastructure Containerized",
		value: "OpenStack-infra-container",
	},
	{
		text: "OpenStack VNF",
		value: "OpenStack-vnf",
	},
	{
		text: "OpenStack Containerized",
		value: "OpenStack-app-container",
	},
];

export const projectContainerTypes = [
	{
		text: "Container Image",
		value: "container",
	},
	{
		text: "Operator Bundle Image",
		value: "operator bundle image",
	},
	{
		text: "Scratch",
		value: "scratch",
	},
];

export const CertificationStatus = [
	{
		text: "Started",
		value: "started",
	},
	{
		text: "Published",
		value: "published",
	},
	{
		text: "In Progress",
		value: "in progress",
	},
	{
		text: "Incomplete",
		value: "incomplete",
	},
];
